export default "__VITE_ASSET__lefENBim__"